import React, { useEffect, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from "uuid";
import { RootState } from 'store/types'
import * as S from './styles';
import moment from 'moment';
import DatePicker from 'components/DateRangePicker/index'
import { SaveUserSettingsAPI, UpdateUserSettingsAPI } from 'features/Dealers/Performance/state/actions'
import { SetRangeDates } from 'features/Dealers/Performance/state/actions';
import { UserSetting } from 'features/Dealers/Performance/state/types';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';

export interface IProps {
    performanceReportProps: any;
}

const Calendar: React.FC<IProps> = ({performanceReportProps}) => {
    const [date, setDate] = React.useState<{ startDate: moment.Moment, endDate: moment.Moment }|undefined>(undefined);
    const dispatch = useDispatch();

    const rootProps = useSelector((rootState: RootState) => {
        return {
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            userSettings: rootState.dealers.offerInsights.userSettings,
            user:rootState.security.user,
            dateRange: rootState.dealers.offerInsights.datesRange
        }
    }, shallowEqual);

    useEffect(() => {
        if(rootProps.selectedDealer && date){ 
            dispatch(SetRangeDates(date)); 
            if (date) {
                let userInfo: UserSetting = {
                    id: uuidv4(),
                    entityType: "USERSETTINGS",
                    user: rootProps.user?.email??'',
                    performanceReportDateRange: date,
                };
                
                if (rootProps.userSettings && rootProps.userSettings.performanceReportDateRange!==date) {
                    userInfo.id = rootProps.userSettings.id;
                    userInfo.entityType = rootProps.userSettings.entityType;
                    dispatch(UpdateUserSettingsAPI(userInfo));
                } else if (!rootProps.userSettings) dispatch(SaveUserSettingsAPI(userInfo));
            }
        }
    }
    , [date]);

    function formatDate(date?: Date)
    {
        if(!date) return '';
        let stringDate : string = new Intl.DateTimeFormat('en-US', {month:'short',day:'numeric',year:'numeric'}).format(new Date(date));
        return stringDate.replace('.','');
    }

    return (
        <S.DatesFromToMainContainer>
            <S.DatesFromToContainer>
                <DatePicker
                dateFormat={"MMM DD, YYYY"}
                startDate={date?.startDate??rootProps.dateRange?.startDate??moment(performanceReportProps.sinceDate)}
                endDate={date?.endDate??rootProps.dateRange?.endDate??moment(performanceReportProps.endDate)}
                onDatesChange={(dateSelected: { startDate: moment.Moment, endDate: moment.Moment }) => {
                    if (dateSelected.endDate.valueOf()!==date?.endDate.valueOf() || dateSelected.startDate.valueOf()!==date?.startDate.valueOf())  
                        setDate(dateSelected)
                }}/>
            </S.DatesFromToContainer>
            
            {!rootProps.userSettings  &&
            <S.FromToToolTipContainer>
                <S.DatesToolTipText>
                    {formatDate(performanceReportProps.sinceDate)} is the date your account was
                    first synced with Google Business Profile.
                </S.DatesToolTipText>
            </S.FromToToolTipContainer>}

            
        </S.DatesFromToMainContainer>
    );
}

export default Calendar;